module.exports = __webpack_public_path__ + "static/media/spotify_icon.0a624299.svg";